(function ($) {
  DJ.addBehavior('innerTabs', '.inner-tabs', {
    attach: function () {
      const innerTabs = this;
      const navigationBtn = innerTabs.querySelectorAll('.inner-tabs__button');
      const navigationBtnActiveClass = 'inner-tabs__button--active';
      const tabBody = innerTabs.querySelector('.inner-tabs__body');
      const tabContent = tabBody.querySelectorAll('.inner-tabs__tab');
      const tabContentHiddenClass = 'inner-tabs__tab--hidden';

      /**
       * Init tabs:
       * - Hide tabs when a script is fired.
       * - Open open the first tab.
       */

      const initTabs = () => {
        $(tabContent).addClass(tabContentHiddenClass);
        const href = $(navigationBtn[0]).attr('href');

        $(`a[href="${href}"]`).addClass(navigationBtnActiveClass);
        $(tabContent[0]).removeClass(tabContentHiddenClass);
      };

      initTabs();

      /**
       * Open tab on button click
       */
      $(navigationBtn).on('click', function () {
        const $thisButton = jQuery(this);
        const href = $thisButton.attr('href');

        if (!($thisButton.hasClass(navigationBtnActiveClass))) {
          $(navigationBtn).removeClass(navigationBtnActiveClass);
          $thisButton.addClass(navigationBtnActiveClass);
          $(tabContent).addClass(tabContentHiddenClass);
          $(tabBody).find(`.${href.substring(1)}`).removeClass(tabContentHiddenClass);
        }

        return false;
      });
    }
  });
})(jQuery);
